module.exports = __webpack_public_path__ + "static/Foodpanda-47a6ed75d2d7d33745be38c8760c40a9.jpg";